import * as React from 'react';
import { NoSsr } from '@cian/react-utils';

import { AboutRealtorDesktopContainer } from '../../../../containers/aboutRealtor';
import { Aside } from '../../../aside';
import { Section } from '../../../common/section';
import { ContentContainer } from '../../../content/container';
import { OffersContainer } from '../../../offers/container';
import { ReviewFormContainer } from '../../../review_form/container';
import { ReviewsHeaderContainer } from '../../../reviews_header/container';
import { ReviewsListContainer } from '../../../reviews_list/container';
import { ChatModalContainer } from '../../../../containers/ChatModalContainer';

import * as styles from './index.css';
import { IconActionArrowLeft24 } from '@cian/ui-kit-design-tokens/icons';
import { Link } from '@cian/ui-kit';

export const ViewDesktop = () => (
  <div className={styles['container']}>
    <div className={styles['back_button']}>
      <Link
        href="/realtors/"
        fontSize="S"
        beforeIcon={<IconActionArrowLeft24 color="icon-main-default" />}
        spacingSize="XS"
      >
        Все специалисты
      </Link>
    </div>
    <div className={styles['content']}>
      <main className={styles['main']}>
        <AboutRealtorDesktopContainer />
        <Section className={styles['reviews']}>
          <ReviewsHeaderContainer />
          <ReviewsListContainer />
          <ReviewFormContainer staticForm />
        </Section>
        <ContentContainer />
      </main>
      <aside className={styles['aside']}>
        <Aside />
      </aside>
      <NoSsr>
        <OffersContainer />
      </NoSsr>
      <NoSsr>
        <ChatModalContainer />
      </NoSsr>
    </div>
  </div>
);
